var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGu = function SvgGu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M5.236 21.912A11.944 11.944 0 0 0 12 24c2.509 0 4.837-.77 6.763-2.087L12 20.87l-6.764 1.043ZM18.764 2.087A11.944 11.944 0 0 0 12.001 0C9.49 0 7.163.77 5.237 2.087l6.764 1.043 6.763-1.043Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0052B4",
    d: "M24 12c0-3.97-2.377-7.958-5.236-9.913H5.237A11.987 11.987 0 0 0 0 12c0 4.119 2.075 7.752 5.237 9.913h13.526A11.987 11.987 0 0 0 24 12Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M11.321 19.575c-.164-.14-4.016-3.49-4.016-7.575s3.852-7.434 4.016-7.575l.68-.582.678.582c.164.14 4.017 3.49 4.017 7.575s-3.853 7.434-4.017 7.575l-.679.582-.679-.582Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#338AF3",
    d: "M15.652 12C15.652 8.348 12 5.217 12 5.217S8.348 8.348 8.348 12c0 1.117.342 2.185.816 3.13h5.671c.475-.945.817-2.013.817-3.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0052B4",
    d: "M15.652 12c0 1.118-.342 2.186-.816 3.13L12 15.654l-2.836-.522c-.474-.945-.816-2.013-.816-3.13h7.304Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA44",
    d: "M12 18.782s1.759-1.508 2.835-3.652h-5.67C10.24 17.274 12 18.782 12 18.782Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6DA544",
    d: "M9.651 9.913h4.696l-2.348 2.347-2.348-2.347Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A2001D",
    d: "M12.783 11.477h-1.565v4.696h1.565v-4.696Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgGu;